/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uuid from 'uuid/v4';
import {
  FLEX_STUDY_TAG, ACTION_TYPE_TOOL_GRID } from '../../constants';
// import GenericFileUpload from '../common/GenericFileUpload';
import DraggableToolPaletteHeader from '../crosstab/DraggableToolPaletteHeader';
import DraggableToolPaletteGrid from '../crosstab/DraggableToolPaletteGrid';
import { saveTrackingData, getActionName } from '../../util/trackerUtils';
import * as mmeActions from '../../actions/mmeActions';
import * as MMEUtils from '../../util/MMEUtils';
import GenericButton from '../common/GenericButton';
import Modal from '../common/Modal/Modal';
import infoIconBlackOutline from '../../images/insight360/info-icon_black_outline.png';

const defaultCount = {
  BasesDataGrid: 1,
  TargetsDataGrid: 5,
  StandardBases: 1,
};

const runReportModalStyle = {
  width: '30%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

class MMEToolPalette extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mmeStudy: props.mmeStudy,
      BasesDataGrid: props.BasesDataGrid || [],
      TargetsDataGrid: props.TargetsDataGrid || [],
      studies: props.studies && props.studies.length > 0 ? props.studies : [],
      selectedOptions: {},
      selectedBase: props.selectedBase,
      // activeMMETable: props.activeMMETable ? props.activeMMETable : {},
      showMore: {
        BasesDataGrid: false,
        TargetsDataGrid: false,
        StandardBases: false,
      },
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.BasesDataGrid !== this.props.BasesDataGrid && nextProps.BasesDataGrid) {
      this.setState({
        BasesDataGrid: nextProps.BasesDataGrid,
      });
    }
    if (nextProps.TargetsDataGrid !== this.props.TargetsDataGrid && nextProps.TargetsDataGrid) {
      this.setState({
        TargetsDataGrid: nextProps.TargetsDataGrid,
      });
    }

    if (nextProps.runReportFlag) {
      this.setState({ selectedOptions: {} });
    }

    if (nextProps.selectedBaseNodeValue !== this.props.selectedBaseNodeValue) {
      if(this.props.isEnableMMEViewer)
        this.props.runMMEReport(this.props.landingTarget, '', nextProps.selectedBaseNodeValue);
    }

    if (nextProps.BasesDataGrid !== this.props.BasesDataGrid && nextProps.BasesDataGrid) {
      // if (this.props.dataScreen !== VISAHAUL_CONSTANT && this.props.dataScreen !== DATAHAUL_CONSTANT) {
      //  this.toggle2.checked = nextProps.bases && nextProps.bases.length > 0;
      this.state.userToggled = false;
      if (nextProps.BasesDataGrid.length > 0 && this.state.userToggled === false) {
        let existingNodeFlag = false;
        nextProps.BasesDataGrid.map(node => {
          if (nextProps.selectedBaseNode === node.keyword && nextProps.selectedBaseGroup === 'user-defined') {
            existingNodeFlag = true;
            this.props.mmeActions.setSelectedBase(node.id, node.keyword, 'user-defined');
          }
          return null;
        });

        if (!existingNodeFlag) {
          if (nextProps.BasesDataGrid.length > 0 && this.props.BasesDataGrid.length === 0) {
            this.props.mmeActions.setSelectedBase(nextProps.BasesDataGrid[0].id,
              nextProps.BasesDataGrid[0].keyword, 'user-defined');
          } else if (nextProps.selectedBase === MMEUtils.DEFAULT_MME_DATA_KEYS.Study_UNIVERSE) {
            this.props.mmeActions.setSelectedBase(
                MMEUtils.DEFAULT_MME_DATA_KEYS.Study_UNIVERSE,
                MMEUtils.DEFAULT_MME_DATA_KEYS.Study_UNIVERSE,
                MMEUtils.DEFAULT_MME_DATA_KEYS.Study_UNIVERSE);
          } else if (nextProps.standardBaseLists.length > 0) {
            let existingSelectedStandardBase = false;

            nextProps.standardBaseLists.map(element => {
              if (nextProps.selectedBaseNode === element.expression &&
                nextProps.selectedBaseGroup === 'standard-base') {
                existingSelectedStandardBase = true;
                this.props.mmeActions.setSelectedBase(element.expression, element.expression, 'standard-base');
              }
              return null;
            });
            if (!existingSelectedStandardBase) {
              this.props.mmeActions.setSelectedBase(nextProps.BasesDataGrid[0].id,
                nextProps.BasesDataGrid[0].keyword, 'user-defined');
            }
          } else {
            this.props.mmeActions.setSelectedBase(nextProps.BasesDataGrid[0].id,
              nextProps.BasesDataGrid[0].keyword, 'user-defined');
          }
        }
      } else if (nextProps.BasesDataGrid.length === 0) {
        this.props.mmeActions.setSelectedBase(
            MMEUtils.DEFAULT_MME_DATA_KEYS.Study_UNIVERSE,
            MMEUtils.DEFAULT_MME_DATA_KEYS.Study_UNIVERSE,
            MMEUtils.DEFAULT_MME_DATA_KEYS.Study_UNIVERSE);
      }
    } else if (nextProps.selectedBase === undefined) {
      this.props.mmeActions.setSelectedBase(
        MMEUtils.DEFAULT_MME_DATA_KEYS.Study_UNIVERSE,
        MMEUtils.DEFAULT_MME_DATA_KEYS.Study_UNIVERSE,
        MMEUtils.DEFAULT_MME_DATA_KEYS.Study_UNIVERSE);
    }
    if (
      this.props.mmeStudy !== nextProps.mmeStudy &&
      nextProps.mmeStudy
    ) {
      this.setState({
        mmeStudy: nextProps.mmeStudy,
      });
    }
    if (
      (nextProps.BasesDataGrid !== this.props.BasesDataGrid && nextProps.BasesDataGrid) ||
      (nextProps.TargetsDataGrid !== this.props.TargetsDataGrid && nextProps.TargetsDataGrid)
    ) {
      if (this.toggle10) {
        this.toggle10.checked =
          (nextProps.BasesDataGrid && nextProps.BasesDataGrid.length > 0) ||
          (nextProps.TargetsDataGrid && nextProps.TargetsDataGrid.length > 0);
      }
      if (nextProps.BasesDataGrid !== this.props.BasesDataGrid && nextProps.BasesDataGrid) {
        if (this.toggle02) {
          this.toggle02.checked = nextProps.BasesDataGrid && nextProps.BasesDataGrid.length > 0;
        }
      }
      if (nextProps.TargetsDataGrid !== this.props.TargetsDataGrid && nextProps.TargetsDataGrid) {
        if (this.toggle03) {
          this.toggle03.checked =
            nextProps.TargetsDataGrid && nextProps.TargetsDataGrid.length > 0;
        }
      }
    }
  }

  getSelectedTargets = gridType =>
  this.props[gridType].filter(
    gridData => this.state.selectedOptions[gridData.id] >= 0,
  );

  selectGridItem = (e, gridEntryid, index) => {
    if (e.ctrlKey || e.metaKey) {
      this.setState((prevState) => ({
        selectedOptions: {
          ...prevState.selectedOptions,
          [gridEntryid]: index,
        },
      }));
    } else if (e.shiftKey) {
      console.warn(gridEntryid);
    } else {
      this.setState({
        selectedOptions: {
          [gridEntryid]: index,
        },
      });
    }
  };

  renderToggleButton = (gridEntryId, gridType) => {
    if (gridType === 'BasesDataGrid' || gridType === 'StandardBases') {
      return (
        <span className="radio-toggle">
          <label className="rb-switcher blue" htmlFor={gridEntryId}>
            <input
              type="radio"
              name="study"
              id={gridEntryId}
              checked={this.props.selectedBase === gridEntryId}
              onClick={() => this.handleBaseSelectionChange(gridEntryId, gridType)}
            />{' '}
            <i />
          </label>
        </span>
      );
    }
    return false;
  };

  handleBaseSelectionChange = (selectedBaseID) => {
    if ((this.props.BasesDataGrid && this.props.BasesDataGrid.length > 0)
      || selectedBaseID === 'StudyUniverseKey') {
      const selectedBaseArray = this.props.BasesDataGrid.filter(
        elment => elment.id === selectedBaseID,
      );

      let selectedBase = 0;
      if (selectedBaseArray.length) {
        // eslint-disable-next-line no-unused-vars
        selectedBase =
          this.props.BasesDataGrid.indexOf(selectedBaseArray[0]) + 1;
      }
      if (selectedBaseArray[0] || selectedBaseID === 'StudyUniverseKey') {
        this.props.mmeActions.setSelectedBase(selectedBaseID,
          selectedBaseID === 'StudyUniverseKey' ? selectedBaseID : selectedBaseArray[0].keyword, 'user-defined');
      }
      this.setState({ userToggled: true });
    }
    if (this.props.standardBaseLists && this.props.standardBaseLists.length > 0
      && selectedBaseID !== 'StudyUniverseKey') {
      const selectedStandardBaseArray = this.props.standardBaseLists.filter(
        elment => elment.expression === selectedBaseID,
      );
      if (selectedStandardBaseArray[0]) {
        this.props.mmeActions.setSelectedBase(selectedBaseID, selectedStandardBaseArray[0].expression, 'standard-base');
      }
      this.setState({ userToggled: true });
    }
  }

  handleTargetDrop = (gridData, destinationGridType) => {
    if (destinationGridType !== gridData.gridType) {
      const newGridData = gridData.selectedNodes.map(node => ({
        ...node,
        id: uuid(),
      }));
      this.props.mmeActions.updateSampleWeighted(
        [...this.state[destinationGridType], ...newGridData],
        destinationGridType,
      );
      this.setState({ selectedBase: newGridData[0].id });
    }
  };

  showStandardBases = () => {
    if (this.props.standardBaseLists.length > defaultCount.StandardBases &&
      this.state.showMore.StandardBases) {
      return this.props.standardBaseLists.slice(0,
        this.props.standardBaseLists.length).map((element, index) => {
          return (
            <div key={element.expression + index} className="base-grid-items line-height">
              {this.renderToggleButton(element.expression, 'StandardBases')}
              <p className="crosstab-recent-item-title">
                <span onClick={() => this.handleBaseSelectionChange(element.expression, 'StandardBases')}>
                  {element.label}
                </span>
              </p>
            </div>
          );
        });
    } if (this.props.standardBaseLists && this.props.standardBaseLists.length > 0) {
      return this.props.standardBaseLists.slice(0, defaultCount.StandardBases)
        .map((element, index) => {
          return (
            <div key={element.expression + index} className="base-grid-items line-height">
              {this.renderToggleButton(element.expression, 'StandardBases')}
              <p className="crosstab-recent-item-title">
                <span onClick={() => this.handleBaseSelectionChange(element.expression, 'StandardBases')}>
                  {element.label}
                </span>
              </p>
            </div>
          );
        });
    }
    return null;
  };

  renderLength = data => (data ? data.length : 0);

  showMoreItems = (data, dataGrid, toggleLabelFlag) => {
    if (data.length > defaultCount[dataGrid] && this.state.showMore[dataGrid]) {
      return this.renderGrids(data.slice(defaultCount[dataGrid]), dataGrid, toggleLabelFlag);
    }
    return null;
  };

  showMoreLabel = (data, dataGrid) => {
    if (data.length > defaultCount[dataGrid]) {
      if (this.state.showMore[dataGrid]) {
        return (
          <button
            type="button"
            data-test="MoreBtn"
            className="more-btn"
            onClick={() => this.setState((prevState) => ({
              showMore: { ...prevState.showMore, [dataGrid]: false },
            }))}
          >
            <strong>Less</strong>
          </button>
        );
      }
      return (
        <button
          type="button"
          data-test="MoreBtn"
          className="more-btn"
          onClick={() => this.setState((prevState) => ({ showMore: { ...prevState.showMore, [dataGrid]: true } }))}
        >
          <strong title={this.props.selectedBase}>More</strong>
        </button>
      );
    }
    return null;
  };

  callSaveTrackerFn = ({ action }) => {
    const productNo = this.props.mmeStudy !== undefined ?
      this.props.mmeStudy.pn : undefined;
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      productNo,
      moduleName: this.props.dataScreen !== undefined ? this.props.dataScreen : 'MME',
      action,
    });
  }

  deleteSelected = gridType => {
    const filterLen = this.props[gridType].filter(gridData => !(this.state.selectedOptions[gridData.id] >= 0)).length;
    if (this.props[gridType].length > filterLen) {
      if(this.props.isEnableMMEViewer && gridType === 'TargetsDataGrid') 
        this.runReportModal.show();
    }
    this.props.mmeActions.updateSampleWeighted(
      this.props[gridType].filter(
        gridData => !(this.state.selectedOptions[gridData.id] >= 0),
      ),
      gridType,
    );
  };

  updateMMETitleHeader = updatedData => {
    let gridCategory = '';
    let originalList = [];
    let index = 0;
    switch (updatedData.gridCategory) {
      case 'BasesDataGrid': gridCategory = 'base'; break;
      case 'TargetsDataGrid': gridCategory = 'target'; break;
      default: gridCategory = '';
    }
    if (gridCategory !== '' && gridCategory === 'base') {
      originalList = this.props.BasesDataGrid;
    } else {
      originalList = this.props.targets;
    }
    if (originalList.length !== 0) {
      index = originalList.findIndex(item => {
        if (item.keyword === updatedData.keyword) {
          return true;
        }
        return false;
      });
      updatedData.index = index;
    }
    this.props.mmeActions.updateMMETitleHeader(updatedData);
  }

  isEditButtonEnabled = gridType => {
    const selectedGridEntries = this.props[gridType].filter(
      gridData => this.state.selectedOptions[gridData.id] >= 0,
    );
    if (selectedGridEntries.length === 1) {
      return 'edit-selected';
    }
    return 'edit-selected hidden';
  };

  handleEditButton = gridType => {
    const action = getActionName(ACTION_TYPE_TOOL_GRID, gridType);
    if (action) {
      this.callSaveTrackerFn({ action });
    }
    const selectedGridEntries = this.props[gridType].filter(
      gridData => this.state.selectedOptions[gridData.id] >= 0,
    );
    if (selectedGridEntries.length === 1) {
      this.props.handleMMEEdit(
        selectedGridEntries[0].id,
        selectedGridEntries[0].dataSmartSearch,
        selectedGridEntries[0].keyword,
      );
    }
  };

  updateGridData = (currentObject, updatedObjectProps, gridType) => {
    const updatedObject = {
      ...currentObject,
      ...updatedObjectProps,
    };
    this.props.mmeActions.updateSampleWeighted(
      this.props[gridType].reduce((acc, currentValue) => {
        if (currentValue.id === updatedObject.id) {
          acc.push({
            ...currentValue,
            ...updatedObject,
          });
        } else {
          acc.push(currentValue);
        }
        return acc;
      }, []),
      gridType,
    );
    if(this.props.isEnableMMEViewer && gridType === 'TargetsDataGrid')
      this.runReportModal.show();
  };

  renderGrids = (gridData, gridType, toggleLabelFlag) =>
  gridData.map((gridEntry, index) => {
    let gridTitle;
    if (gridEntry.dataSmartSearch && gridEntry.dataSmartSearch.objectsAdded) {
      const objectsAdded = gridEntry.dataSmartSearch.objectsAdded;
      if (objectsAdded.length > 0 && objectsAdded.length === 1) {
        gridTitle = `${objectsAdded[0].shortTextCatgView} : ${objectsAdded[0].breadcrumbs}`;
      } else {
        gridTitle = '';
        objectsAdded.forEach(item => {
          let textValue = '';
          if (item.breadcrumbs) {
            textValue = `${item.shortTextCatgView} : ${item.breadcrumbs}`;
          } else if (item.objectType === 'operator') {
            textValue = `${textValue} ${item.shortText} `;
          }
          gridTitle += textValue;
        });
      }
    }
    return (<DraggableToolPaletteGrid
      key={gridEntry.id}
      gridEntry={gridEntry}
      index={index}
      gridType={gridType}
      getSelectedTargets={this.getSelectedTargets}
      handleBaseSelectionChange={
        this.props.mmeStudy &&
          !this.props.mmeStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
          ? this.handleBaseSelectionChange
          : undefined
      }
      selectedOptions={this.state.selectedOptions}
      selectGridItem={this.selectGridItem}
      selectedPreviewItems={() =>
        this.state[gridType].filter(
          grid => this.state.selectedOptions[grid.id] >= 0,
        )
      }
      renderToggleButton={this.renderToggleButton}
      handleTargetDrop={this.handleTargetDrop}
      updateGridData={this.updateGridData}
      crosstabStudy={this.props.mmeStudy.st}
      updateCrosstabTitleHeader={this.updateMMETitleHeader}
      tooltipVal={gridTitle}
      toggleLabelFlag={toggleLabelFlag}
    />);
  });

  renderRowsColumnsBases = (data, dataGrid, toggleLabelFlag) => (
    this.renderGrids(data.slice(0, defaultCount[dataGrid]), dataGrid, toggleLabelFlag)
  );

  /* openCrosstabs = () => {
    this.callSaveTrackerFn({ action: TOOL_OPEN_MME });
    this.props.mmeActions.showSavedMMEs(
      this.props.loginResponse.data.token,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
    );
  } */

  render() {
    return (<div className="width-20 minimize-tp float-left" data-list="MMEToolPaletteComp">
      <ul className="accordion tool_bg">
        {/* <li className="accordion__item">
          <input
            type="checkbox"
            className="accordion__toggle"
            id="toggle-01"
          />
          <label
            className="accordion__trigger tool_img open_tool"
            htmlFor="toggle-01"
            title="Open"
          >
            Open
          </label>
          <div className="accordion__target padding-rl20">
            <button
              className="chart-type"
              onClick={this.openCrosstabs}
            >
              <p className="open" title="OPEN CROSSTAB">open crosstab</p>
            </button>
            <div className="chart-type">
              <GenericFileUpload
                id="spc-upload"
                btnStyle="import"
                //handleUpload={this.handleImportSPC}
                title="IMPORT .SPC"
                btnDisabled={false}
                name="import .spc"
                //trackerFn={this.importSPCHandler}
              />
            </div>
          </div>
        </li>

        <li className="accordion__item">
          <input
            type="checkbox"
            className="accordion__toggle"
            id="toggle-08"
          />
          <label
            className="accordion__trigger tool_img save_tool"
            htmlFor="toggle-08"
            title="Save"
          >
            Save
          </label>
        </li> */}

        <li className="accordion__item">
          <input
            type="checkbox"
            className="accordion__toggle"
            id="toggle-07"
          />
          <label
            className="accordion__trigger tool_img export_tool"
            htmlFor="toggle-07"
            title="Export"
          >
            Export
          </label>
          <div className="accordion__target padding-rl20">
            <div>
              <button
                type="button"
                className={this.props.isEnableMMEViewer ? 'chart-type' : 'chart-type export-disabled'}
                onClick={() =>
                  this.props.exportMMEReport()
                }
              >
                <p
                  className="export_xls"
                  title="EXPORT .XLS"
                >export .xls</p>
              </button>
            </div>
          </div>
        </li>

        <li className="accordion__item">
          <input
            type="checkbox"
            className="accordion__toggle"
            id="toggle-10"
            // eslint-disable-next-line no-return-assign
            ref={node => (this.toggle10 = node)}
          />
          <label
            className="accordion__trigger tool_img grid_tool"
            htmlFor="toggle-10"
            title="Grid"
          >
            Grid
          </label>
          <div className="accordion__target">
            <ul className="marginl_5">
              <li className="accordion__item">
                <input
                  type="checkbox"
                  className="accordion__toggle"
                  id="toggle-02"
                  ref={node => (this.toggle02 = node)}
                />
                <DraggableToolPaletteHeader
                  renderLength={this.renderLength}
                  toggleNo="toggle-02"
                  title="BASES"
                  dataGridItems={this.props.BasesDataGrid}
                  standardBaseCount={this.props.standardBaseLists ?
                        this.props.standardBaseLists.length : 0}
                  handleTargetDrop={this.handleTargetDrop}
                  gridType="BasesDataGrid"
                  icon="bases_tool"
                  study={
                           this.props.mmeStudy
                              ? this.props.mmeStudy.st
                              : undefined
                          }
                />
                <div className="accordion__target toolpalette-items">
                  <p
                    className="crosstab-recent-item-title"
                    onClick={
                      this.props.mmeStudy &&
                      !this.props.mmeStudy.st
                        .toLowerCase()
                        .includes(FLEX_STUDY_TAG)
                        ? () =>
                        this.handleBaseSelectionChange(
                          MMEUtils.DEFAULT_MME_DATA_KEYS
                          .Study_UNIVERSE,
                        )
                        : () => { }
                    }
                  >
                    {this.props.mmeStudy &&
                    !this.props.mmeStudy.st
                      .toLowerCase()
                      .includes(FLEX_STUDY_TAG) && (
                      <DraggableToolPaletteGrid
                        isStudyUniverse
                        gridType="BasesDataGrid"
                        handleTargetDrop={this.handleTargetDrop}
                        mmeStudy={this.props.mmeStudy.st}
                        updateCrosstabTitleHeader={this.updateMMETitleHeader}
                        toggleLabelFlag
                      />
                      )}
                  </p>
                  {this.props.mmeStudy &&
                    !this.props.mmeStudy.st
                    .toLowerCase()
                    .includes(FLEX_STUDY_TAG) &&
                    this.renderToggleButton(
                      MMEUtils.DEFAULT_MME_DATA_KEYS
                      .Study_UNIVERSE,
                      'BasesDataGrid',
                    )}
                  <div className="base-header">USER-DEFINED</div>
                  <div className="clear-section">
                    <span
                      className="clear-all"
                      onClick={() => {
                        this.props.mmeActions.clearSampleWeighted(
                        'BasesDataGrid',
                        );
                      }
                    }
                    >
                      CLEAR ALL
                    </span>
                    <span />
                    <span
                      className={this.isEditButtonEnabled('BasesDataGrid')}
                      onClick={() => this.handleEditButton('BasesDataGrid')}
                    />
                    <span
                      className="delete-selected"
                      onClick={() => this.deleteSelected('BasesDataGrid')}
                    />
                  </div>
                  {this.renderRowsColumnsBases(
                    this.props.BasesDataGrid,
                        'BasesDataGrid',
                        true,
                  )}
                  {this.showMoreItems(
                    this.props.BasesDataGrid,
                    'BasesDataGrid',
                    true,
                  )}
                  {this.showMoreLabel(
                    this.props.BasesDataGrid,
                    'BasesDataGrid',
                  )}
                  {this.props.mmeStudy && !this.props.loginResponse.data.universityUser &&
                    !this.props.mmeStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
                    ? <div className="standard-base-header">STANDARD
                      <img
                        className="standard_base_info_icon"
                        src={infoIconBlackOutline}
                        alt="Selection of predefined bases built by Simmons"
                        title="Selection of predefined bases built by Simmons"
                      />
                    </div>
                      : null}
                  {this.props.mmeStudy && !this.props.loginResponse.data.universityUser &&
                    !this.props.mmeStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
                    ? this.props.standardBaseLists &&
                      this.showStandardBases(this.props.standardBaseLists, 'StandardBases')
                    : null}
                  {this.props.mmeStudy && !this.props.loginResponse.data.universityUser &&
                    !this.props.mmeStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
                    ? this.props.standardBaseLists && this.showMoreLabel(this.props.standardBaseLists, 'StandardBases')
                    : null}
                </div>
              </li>

              <li className="accordion__item">
                <input
                  type="checkbox"
                  className="accordion__toggle"
                  id="toggle-03"
                  ref={node => (this.toggle03 = node)}
                />
                <DraggableToolPaletteHeader
                  renderLength={this.renderLength}
                  toggleNo="toggle-03"
                  title="TARGETS"
                  dataGridItems={this.props.TargetsDataGrid}
                  standardBaseCount={this.props.TargetsDataGrid ?
                        this.props.TargetsDataGrid.length : 0}
                  handleTargetDrop={this.handleTargetDrop}
                  gridType="TargetsDataGrid"
                  icon="targets_tool"
                  study={
                          this.props.mmeStudy
                            ? this.props.mmeStudy.st
                            : undefined
                        }
                  targetCountFlag
                />
                <div className="accordion__target toolpalette-items">
                  <div className="">
                    <span
                      className="clear-all"
                      onClick={() => {
                        this.props.mmeActions.clearSampleWeighted(
                          'TargetsDataGrid',
                        );
                        if(this.props.isEnableMMEViewer)
                          this.runReportModal.show();
                      }
                     }
                    >
                      CLEAR ALL
                    </span>
                    <span />
                    <span
                      className={this.isEditButtonEnabled('TargetsDataGrid')}
                      onClick={() => this.handleEditButton('TargetsDataGrid')}
                    />
                    <span
                      className="delete-selected"
                      onClick={() => this.deleteSelected('TargetsDataGrid')}
                    />
                  </div>
                  {this.renderRowsColumnsBases(
                    this.props.TargetsDataGrid,
                        'TargetsDataGrid',
                        true,
                  )}
                  {this.showMoreItems(
                    this.props.TargetsDataGrid,
                    'TargetsDataGrid',
                    true,
                  )}
                  {this.showMoreLabel(
                    this.props.TargetsDataGrid,
                    'TargetsDataGrid',
                  )}
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <Modal
        title="Run Report"
        ref={node => (this.runReportModal = node)}
        dialogStyles={runReportModalStyle}
      >
        <p>A data point was added, edited or deleted.</p>
        <p>Please run your report again to view updated selection(s).</p>
        <div className="text-right">
          <GenericButton
            name="Ok"
            onBtnClick={() => this.runReportModal.hide()}
          />
        </div>
      </Modal>
    </div>
    );
  }
}

MMEToolPalette.propTypes = {
  targets: PropTypes.arrayOf(PropTypes.object),
  mmeStudy: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    pn: PropTypes.number,
    st: PropTypes.string,
  })]),
  studies: PropTypes.instanceOf(Array),
  selectedBaseNode: PropTypes.string,
  selectedBaseNodeValue: PropTypes.string,
  selectedBaseGroup: PropTypes.string,
  selectedBase: PropTypes.string,
  activeAccountId: PropTypes.number,
  dataScreen: PropTypes.string,
  mmeActions: PropTypes.shape({
    updateSampleWeighted: PropTypes.func,
    clearSampleWeighted: PropTypes.func,
    updateMMETitleHeader: PropTypes.func,
    setSelectedBase: PropTypes.func,
    updateMMEGrid: PropTypes.func,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      universityUser: PropTypes.bool,
    }),
  }),
  handleMMEEdit: PropTypes.func,
  BasesDataGrid: PropTypes.arrayOf(PropTypes.object),
  TargetsDataGrid: PropTypes.arrayOf(PropTypes.object),
  standardBaseLists: PropTypes.arrayOf(PropTypes.object),
  isEnableMMEViewer: PropTypes.bool,
  exportMMEReport: PropTypes.func,
  landingTarget: PropTypes.string,
  runMMEReport: PropTypes.func,
  runReportFlag: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    selectedBase: state.mme.selectedBase.selectedBase,
    standardBaseLists: state.mme.standardBaseLists,
    isEnableMMEViewer: state.mme.isEnableMMEViewer,
    selectedBaseNodeValue: state.mme.selectedBase.selectedBaseNode,
    runReportFlag: state.mme.runReportFlag,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    mmeActions: bindActionCreators(mmeActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MMEToolPalette);
